module.exports = __webpack_public_path__ + "media/fonts/Unica77LLTT-Regular--118b443e9dd57474c89db06dea7bfc7a.eot";